export class DeviceSpecification {
  id?: string; // Option[String],
  manufacturer?: string; // String,
  series?: string; // Option[String],
  type?: string; // Option[String],
  softwareLoad?: string; // Option[String], // The software load of the device
  maxUsers?: number; // Int, // The maximum number of lines possible for the device.
  serializer?: string; // Option[String], // The serializer to be used to create the settings file for the device.
  devSpecType?: DeviceSpecificationType; // Option[DeviceSpec.Type.Value] = None,
  userAgent?: string; // Option[String], // The user agent of the device.
  functionKeyAlignment?: string; // Option[String],
  custom?: boolean; // Option[Boolean] = None // Flag to mark custom loads uploaded by the customer
}

export enum DeviceSpecificationType {
  FAX_PRINTER = 'FAX_PRINTER',
  GATEWAY = 'GATEWAY',
  IAD_MASTER = 'IAD_MASTER',
  IAD = 'IAD',
  PHONE = 'PHONE',
  SOFT_CLIENT = 'SOFT_CLIENT',
}
